export const environment = {
  baseUrl: 'https://PreProdColoClicApi.LaColonial.com.do/api',
  apiVersion: '1',
  b2c: {
    clientId: 'c46080f5-adcc-413b-b4f5-5fe283d05bf6',
    authorities: {
      signUpSignIn: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignIn',
      },
      signUp: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignupProducer',
      },
      resetPassword: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_password_reset',
      },
      editProfile: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_profile_edit',
      },
    },
    authorityDomain: 'labloginlacolonial.b2clogin.com',
    redirectUri: 'https://preprodcoloclicspa.lacolonial.com.do/',
    postLogoutRedirectUri: 'https://preprodcoloclicspa.lacolonial.com.do/',
    apiScopes: [
      'https://labloginlacolonial.onmicrosoft.com/95266b60-40fc-4381-ae39-ab7ea9eba3fa/ColoClic.Read',
      'https://labloginlacolonial.onmicrosoft.com/95266b60-40fc-4381-ae39-ab7ea9eba3fa/ColoClic.ReadWrite',
    ],
  },
  aad: {
    clientId: '1fae0e3a-3fe9-498b-97b8-2e6d948bb3df',
    authority: 'https://login.microsoftonline.com/962ac847-59a0-4354-a477-bef920c68440/v2.0',
    redirectUri: 'https://preprodcoloclicspa.lacolonial.com.do/',
    apiScopes: [
      'api://b8a7cb03-d1c6-4dbd-9076-a595108ebfa4/ColoClic.Read',
      'api://b8a7cb03-d1c6-4dbd-9076-a595108ebfa4/ColoClic.ReadWrite',
    ],
  },
  armalotuUrl: 'http://lab.armalotu.com.do/armalotu',
  emprendeseguroUrl: 'https://labemprendeseguro.lacolonial.com.do/home',
  hogarSeguroUrl: 'https://labhogarseguro.lacolonial.com.do/hogarseguro',
  cotizadorUrl: 'https://preprodquote.lacolonial.com.do',
  showDashboard: false,
};
